import React from 'react';
import TodoApp from './components/TodoApp';
import './styles/TodoApp.css';

function App() {
  return (
    <div className="App">
      <TodoApp />
    </div>
  );
}

export default App;